import { isEmpty } from '../utils/common'

export const fundingDataExists = state => {
  const {
    funding: { data },
  } = state

  return !isEmpty(data) && !isEmpty(data?.grantor)
}
